
import Vue from 'vue';

import "../base/layout-bom";

import { registerComponents } from '../base/output/output-fragment-register';
registerComponents();
 
import NormalLayout from './normal.vue';
import store from "./../base/store";

import Logger from "../../shared/logger";
 
const LOGGER = new Logger(__filename);

new Vue({ //NOSONAR 
    store,
    el: '#app',
    render: h => h(NormalLayout),
    mounted() {
        const that = this;
        Vue.nextTick(() => {
            that.$store.dispatch("init");
        });
    }
});

LOGGER.log("==================================");
LOGGER.log("======= NORMAL LAYOUT ============");
LOGGER.log("==================================");


